import {Component, inject} from '@angular/core';
import {MatDialogRef, MatDialogTitle} from '@angular/material/dialog';

@Component({
    standalone: true,
    selector: 'app-dialog-refresh-app',
    templateUrl: './dialog-refresh-app.component.html',
    styleUrls: ['./dialog-refresh-app.component.scss'],
    imports: [MatDialogTitle]
})
export class DialogRefreshAppComponent {
  dialogRef = inject(MatDialogRef<DialogRefreshAppComponent>);

  dismiss() {
    this.dialogRef.close();
  }
}
